/* ============================================================
   SCENE DURATIONS — the length (ms) of every sequence-driven bump
   scene, kept THREE-free so the schedule (live.ts) AND the channel
   cover timer can read it synchronously without the Three.js chunk.

   The numbers are NOT hand-maintained: SCENE_DURATIONS_MS is DERIVED
   from the scenes themselves (each directorkit scene computes its own
   `Σ shot.duration·1000 + tailMs`) and code-generated into
   `durations.generated.ts` by `npm run gen:durations`. The freshness
   test (durations.gen.test.ts) fails CI if a scene's real length ever
   drifts from the committed map.

   Ads need their entry for the broadcast schedule; channel idents/
   stations need theirs so the cover is held exactly as long as the
   scene plays. Looping scenes (sweep, bars…) have no fixed length and
   are absent — they fall back to AD_SCENE_TIMEOUT_MS, the only
   fallback length (also used if a listed scene's promise never resolves).
   ============================================================ */
export { SCENE_DURATIONS_MS } from './durations.generated'
import { SCENE_DURATIONS_MS } from './durations.generated'

/** Global safety net: max time any scene may hold before we move on. */
export const AD_SCENE_TIMEOUT_MS = 5000

/** Scheduled length of a scene, in ms. Falls back to the timeout when the
 *  scene declares no fixed length (e.g. a looping ident). */
export function getSceneDurationMs(scene: string): number {
  return SCENE_DURATIONS_MS[scene] ?? AD_SCENE_TIMEOUT_MS
}
